import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IAddDataQualityIndicatorParams {
  contentName: string;
  contentId: string;
  contentType: string;
  isActive: boolean;
  type: string;
  message: string;
}

export interface IAddDataQualityIndicatorResult extends IResult {

}

export class AddDataQualityIndicatorRequest extends Request<IAddDataQualityIndicatorParams, IAddDataQualityIndicatorResult> {
  constructor(params: IAddDataQualityIndicatorParams) {
    super('addDataQualityIndicator', params);
  }
}
